import type Store from '@ember-data/store';
import type VisitCompositeModel from 'garaje/models/visit-composite';
import type { CursorPaginatedRecordArray } from 'garaje/types/pagination';
import { formatPaginationLinks } from 'garaje/utils/pagination';

import ApplicationSerializer from './application';

export default class VisitCompositeSerializer extends ApplicationSerializer {
  normalizeResponse(
    store: Store,
    primaryModelClass: VisitCompositeModel,
    payload: CursorPaginatedRecordArray<VisitCompositeModel>,
    id: string | number | null,
    requestType: string,
  ): ReturnType<ApplicationSerializer['normalizeResponse']> {
    formatPaginationLinks(payload);
    return super.normalizeResponse(store, primaryModelClass, payload, id, requestType);
  }
}
